import { Component, inject, Input, OnChanges, OnInit } from "@angular/core";
import { CollaboratorsInvitationSuccessComponent } from "./collaborators-invitation-success/collaborators-invitation-success.component";
import { EventsManagementService } from "../../services/events-management.service";
import { EventInfo } from "../../services/types/events-management-request.type";
import { Observable } from "rxjs";
import { CommonModule } from "@angular/common";

@Component({
    selector: "app-collaborators-invitation-success-page",
    imports: [CommonModule, CollaboratorsInvitationSuccessComponent],
    templateUrl: "./collaborators-invitation-success-page.component.html",
    styleUrl: "./collaborators-invitation-success-page.component.scss"
})
export class CollaboratorsInvitationSuccessPageComponent implements OnChanges {
  @Input() eventId?: number;

  private readonly eventsService = inject(EventsManagementService);

  event$!: Observable<EventInfo>;

  ngOnChanges() {
    if (this.eventId != null) {
      this.event$ = this.eventsService.getEventInfo(this.eventId);
    }
  }
}
